<template>
    <div class="container">
          <div class="conmonContent">
              <div class="w1600">
                  <div class="proTop d-flex j-center a-center">
                      <!-- 筛选 -->
                      <div class="searchblock">
                          <div class="inline-block">
                            <search :search_key="pagination.keyword" :search_type="pagination.type" @search="handelSearch"></search>
                        </div>
                      </div> 
                  </div>
                   <div class="categoryFilter bd10">
                    <div class="radios d-flex a-center">
                        <div class="i"><el-radio v-model="pagination.type" label="product">{{ $t('search.product') }}</el-radio></div>
                        <div class="i"><el-radio v-model="pagination.type" label="version">{{ $t('search.package') }}</el-radio></div>
                        <div class="i"><el-radio v-model="pagination.type" label="document">{{ $t('search.document') }}</el-radio></div>
                        <div class="i"><el-radio v-model="pagination.type" label="train">{{ $t('search.train') }}</el-radio></div>
                        <div class="i"><el-radio v-model="pagination.type" label="faq">{{ $t('search.faq') }}</el-radio></div>
                        <div class="i"><el-radio v-model="pagination.type" label="activity">{{ $t('search.activity') }}</el-radio></div>
                    </div>
                    <div class="resultTip font-light d-flex a-center">
                        <div class="a" v-show="pagination.type!='0'">
                            {{ $t('search.result_p1') }}<span v-show="pagination.type=='product'">{{ $t('search.product') }}</span>
                            <span v-show="pagination.type=='version'">{{ $t('search.package') }}</span>
                            <span v-show="pagination.type=='document'">{{ $t('search.document') }}</span>
                            <span v-show="pagination.type=='train'">{{ $t('search.train') }}</span>
                            <span v-show="pagination.type=='faq'">{{ $t('search.faq') }}</span>
                            <span v-show="pagination.type=='activity'">{{ $t('search.activity') }}</span>{{ $t('search.result_p2') }}
                        </div>
                        <div class="b">{{ $t('search.result_p3') }}<span v-show="pagination.keyword">{{pagination.keyword}}</span>{{ $t('search.result_p4') }}<span>{{total}}</span>{{ $t('search.result_p5') }}</div>
                    </div>
                   </div>
                   <!-- 主体列表内容 -->
                   <div :class="['documentContent d-flex j-sb', {active: handleType}]">
                       <!-- 移动端显示分类 -->
                       <div class="handleType a-center j-center" @click="handleType = !handleType">{{ $t('search.category') }}<img src="@/assets/Icons/type.svg" alt="" /></div>
                       <!-- 左侧分类 -->
                       <div class="dcLeft bd10">
                        <div v-show="categoryTree.length>0&&pagination.type!='activity'">
							<div class="eltree bd10 font-light">
                            <h3 class="font18">{{$t('commom.productSeries')}}</h3>
                            <el-tree
                                :data="categoryTree"
                                empty-text=""
                                @check-change="checkChange"
                                show-checkbox
                                node-key="id"
                                ref="checkboxtree"
                                :expand-on-click-node="false"
                                :check-on-click-node="true"
                                :default-checked-keys="optionsSelect"
                                :props="defaultProps">
                            </el-tree>
                           </div>
						 </div>
                         <div v-show="pagination.type=='activity'">
							<div class="eltree bd10 font-light">
                            <h3 class="font18">{{$t('show.activityType')}}</h3>
                            <el-tree
                                :data="activityTree"
                                empty-text=""
                                @check-change="checkChange2"
                                show-checkbox
                                node-key="id"
                                ref="checkboxtree2"
                                :expand-on-click-node="false"
                                :check-on-click-node="true"
                                :default-checked-keys="optionsSelect2"
                                :props="defaultProps">
                            </el-tree>
                           </div>
						 </div>
                       </div>
                       <!-- 右侧列表 -->
                       <div class="proDocument bd10">
                           <div class="conmonDocument bd10">
                               <!-- 筛选 -->
                               <div class="filter d-flex j-sb a-center">
                                   <div class="rForm d-flex a-center">
                                       <div class="sort d-flex a-center">
                                           
                                           <select v-model="pagination.orderBy" @change="handelSort" class="font-light">
                                                <option value="timeDesc">{{ $t('filter.bynew') }}</option>
												<option value="timeAsc">{{ $t('filter.byold') }}</option>
												<option value="titleDesc">{{$t('filter.bytitle')}}</option>
										 </select>
                                         <img src="@/assets/Icons/sort.png" alt="">
                                       </div>
                                   </div>
                                   <div class="showNums d-flex a-center font-light">
                                    {{ $t('filter.page',{a:1,b:pagination.pageSize,c:total}) }}
									 <select name="" v-model="pagination.pageSize" @change="getList" id="" class="font-light">
										<option value="10">{{ $t('filter.pageSize',{a:10}) }}</option>
										<option value="30">{{ $t('filter.pageSize',{a:30}) }}</option>
										<option value="50">{{ $t('filter.pageSize',{a:50}) }}</option>
										<option value="100">{{ $t('filter.pageSize',{a:100}) }}</option>
									 </select>
                                   </div>
                                   
                               </div>
                               <div class="searchList">
                                    <div class="table font-light line-mn">
                                        <dl v-if="pagination.type=='product'">
                                            <dd class="d-flex"  v-for="(item, index) in list" :key="index">
                                                <span class="nowrap2" v-if="item.isIpProject"><a  @click="goToPage('/ipProductDetail?id='+item.id)" href="javascript:;" class="link" :title="item.productName">{{item.productName}}</a></span>
                                                <span class="nowrap2" v-else><a  @click="goToPage('/productDirectory?productId='+item.id)" href="javascript:;" class="link" :title="item.productName">{{item.productName}}</a></span>
                                                <span>{{item.createTime|dateFormate('yyyy-MM-dd')}}</span>
                                            </dd>
                                        </dl>
                                        <dl v-if="pagination.type=='version'">
                                            <dd class="d-flex"  v-for="(item, index) in list" :key="index">
                                                <span class="nowrap2"><a  @click="goToPage('/productPackageDetail?id='+item.id)" href="javascript:;"  class="link" :title="item.name">{{item.name}}</a></span>
                                                <span>{{item.releaseDate|dateFormate('yyyy-MM-dd')}}</span>
                                            </dd>
                                        </dl>
                                        <dl v-if="pagination.type=='document'">
                                            <dd class="d-flex"  v-for="(item, index) in list" :key="index">
                                                <span class="nowrap2"><a :href="item.file" :download="item.title" class="link" :title="item.title">{{item.title}}</a></span>
                                                <span>{{item.releaseDate|dateFormate('yyyy-MM-dd')}}</span>
                                            </dd>
                                        </dl>
                                        <dl v-if="pagination.type=='train'">
                                            <dd class="d-flex"  v-for="(item, index) in list" :key="index">
                                                <span class="nowrap2"><a @click="goToPage('/onlineTrainDetail?id='+item.id)" href="javascript:;" class="link" :title="item.title">{{item.title}}</a></span>
                                                <span>{{item.releaseDate|dateFormate('yyyy-MM-dd')}}</span>
                                            </dd>
                                        </dl>
                                        <dl v-if="pagination.type=='faq'">
                                            <dd class="d-flex"  v-for="(item, index) in list" :key="index">
                                                <span class="nowrap2"><a @click="goToPage('/questionDetail?id='+item.id)" href="javascript:;" class="link" :title="item.title">{{item.title}}</a></span>
                                                <span>{{item.releaseDate|dateFormate('yyyy-MM-dd')}}</span>
                                            </dd>
                                        </dl>
                                        <dl v-if="pagination.type=='activity'">
                                            <dd class="d-flex"  v-for="(item, index) in list" :key="index">
                                                <span class="nowrap2"><a @click="goToPage('/activityDetail?id='+item.id)" href="javascript:;" class="link" :title="item.title">{{item.title}}</a></span>
                                                <span>{{item.time|dateFormate('yyyy-MM-dd')}}</span>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                                <div class="pagination">
                                    <el-pagination
                                        @current-change="handleCurrentChange"
                                        :page-size="10"
                                        layout="prev, pager, next"
                                        :total="total">
                                </el-pagination>
                            </div>
                           </div>
                       </div>
                   </div>
              </div>
          </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SearchResult',
    components: {
      
    },
    data() {
      return {
          // 控制移动端分类的显示/隐藏
          handleType: false,
          // 左侧分类
          leftMenu: [],
          // 活动列表
          list: [],
          // 分页
          pagination: {
              pageNo: 1,
              pageSize: 10,
              keyword: '',
              orderBy:'timeDesc',
              type:'product',
              keyword:"",
              totalCategory:''
          },
          // 数量
          total: 0,
        categoryTree:[],//产品类别
        activityTree:[
            {
                id:1,
                name:this.$t('show.offlineActivity')
            },
            {
                id:2,
                name:this.$t('show.onlineActivity')
            }
        ],//活动类别
        optionsSelect:[],
        optionsSelect2:[],
        defaultProps:{
            label:"name",
            children:"children"
        }
      }
    },
    
    created() {
          // 获取活动
          this.pagination.type=this.$route.query.type;
          this.pagination.keyword=this.$route.query.kw;
          this.getCategory();
          this.getList();
    },
    
    methods: {
          // 页面跳转
          goToPage(path, query={}) {
              this.$router.push({
                  path,
                query
              })
          },
          //获取筛选条件
          getOptions(){
            this.$axios.get('search/selectData')
  		       .then(res => {
  		     	  this.searchOptions = res.data;
  		       })
  		       .catch(err => {})
          },
          getCategory(){//获取类别，初始产品列表
            this.$axios.get(`product/catalogue`)
            .then(res => {
                let data = res.data;
                this.categoryTree = data;
                this.selectAllIds=this.getChildIds({
                    id:'',
                    children:data
                },[]);
                this.selectTemp=this.selectAllIds;
            })
            .catch(err=>{})
        },
        checkChange(){
            var that=this;
            var nodes=that.$refs.checkboxtree.getCheckedNodes(true);
            that.optionsSelect=[];
            nodes.forEach(function(i){
                that.optionsSelect.push(i.id);
            });
            that.pagination.totalCategory=that.optionsSelect.join(',');
            that.getList();
        },
        checkChange2(){
            var that=this;
            var nodes=that.$refs.checkboxtree2.getCheckedNodes(true);
            that.optionsSelect2=[];
            nodes.forEach(function(i){
                that.optionsSelect2.push(i.id);
            });
            that.pagination.totalCategory=that.optionsSelect2.join(',');
            that.getList();
        },
        // 获取列表
        getList() {
  			this.total = 20;
  		    this.$axios.post('search/index', this.pagination)
  		   .then(res => {
  		 	  this.list = res.data.list;
  		 	  this.total = res.data.total;
  		   })
  		   .catch(err => {})
  	  },
        
        // 点击翻页
        handleCurrentChange(current) {
            this.pagination.pageNo = current;
            // 更新
            this.getList();
        },
        handelSearch(e){
            this.pagination.type=e.type;
            this.pagination.keyword=e.key;
            this.getList();
        },
        handelSort(){
            this.pagination.pageNo=1;
            this.getList();
        }
    },
    watch:{
        'pagination.type':function(val){
            var that=this;
            console.log(val);
            that.pagination.pageNo=1;
            that.pagination.type=='activity'?that.checkChange2():that.checkChange();
        }
    },
    filters:{
        dateFormate:function(date,formate){
            if(!date||!formate) return '';
            var year=new Date(date).getFullYear();
            var month=(new Date(date).getMonth()+1)>9?(new Date(date).getMonth()+1):('0'+(new Date(date).getMonth()+1));
            var day=new Date(date).getDate()>9?new Date(date).getDate():('0'+new Date(date).getDate());
            return formate.replaceAll('yyyy',year).replaceAll('MM',month).replaceAll('dd',day);
        }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .eltree{
		padding: .3rem .2rem;
		h3{
			margin-bottom: .2rem;
		}
		/deep/ .el-tree-node__content{
			padding-bottom: .1rem;
			padding-top: .1rem;
			height: auto;
			background: none !important;
		}
		/deep/.is-checked>.el-tree-node__content{
			background: none;
			color: #2657db;
		}
		/deep/.el-tree-node__label{
			font-size: inherit;
			flex: 1 1 auto;
			padding-right: 1em;
			overflow: hidden;
			white-space: normal;
		}
		/deep/ .el-tree-node__expand-icon{
			position: absolute;
			right: 0;
		}
		/deep/.el-checkbox__input.is-checked .el-checkbox__inner, /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner{
			border-color: #2657db;
			background-color: #2657db;
		}
		@media (max-width: 1200px) {
			padding: .2rem;
		}
	}
  .categoryFilter{
    padding: .3rem;
    margin-bottom: 10px;
    .radios{
        margin-bottom: 10px;
        .i{
            margin: 0 .5rem 0 0;
            padding: .1rem 0;
            .el-radio{
                font-size: inherit;
                color: inherit;
                /deep/.el-radio__label,/deep/.el-radio__input{
                    display: inline-block;
                    vertical-align: middle;
                    font-size: inherit;
                }
                /deep/ .el-radio__inner{
                    border-radius: 0;
                    &:after{
                        box-sizing:content-box;content:"";border:1px solid #fff;border-left:0;border-top:0;height:7px;left:4px;position:absolute;top:1px;transform:rotate(45deg) scaleY(0);width:3px;transition:transform .15s ease-in .05s;transform-origin:center;border-radius:0;background:none;
                    }
                }
                &.is-checked{
                    /deep/ .el-radio__inner:after{
                        transform: rotate(45deg) scaleY(1);
                    }
                    /deep/.el-radio__label{
                        color: #003ee5;
                    }
                    /deep/.el-radio__inner{
                        background: #003ee5;
                        border-color: #003ee5;
                    }
                }
            }
        }
    }
    .resultTip{
        color:#999;
        span{
            color: #555;
            padding: 0 5px;
        }
    }
  }
      .proTop{
          padding: .5rem 0;
          .tags{
              span{
                  display: inline-block;
                  padding: 0.05rem 0.08rem;
                  border-radius: 0.15rem;
                  background: #5794f8;
                  color: #fff;
                  margin-right: .1rem;
              }
          }
          .cTopFrom{
              margin: 0;
          }
          @media (max-width: 1200px) {
              display: block;
              .cTopFrom{
                  margin: .3rem auto 0;
              }
          }
      }
      .documentContent{
        align-items: stretch;
        min-height: 65vh;
          .proDocument{
              width: 80%;
              background: #fff;
          }
          .searchList{
            padding-top: .2rem;
          }
          .table{
				dl{
					dt,dd{
						padding: .22rem 0;
					}
					dt{
						background: #f2f5fa;
						border-radius: 5px;
						span:nth-of-type(1) {
							padding-left: .15rem;
						}
					}
					dd{
						&:not(:last-child) {
							border-bottom: solid 1px #eee;
						}
						span:nth-of-type(1) {
							position: relative;
							padding-left: .2rem;
							&:after{
								content: "";
								position: absolute;
								left: 0;
								top: .1rem;
								width: .04rem;
								height: .04rem;
								background: #2657db;
							}
						}
					}
					span{
						.d{
							width: .15rem;
							height: .17rem;
							background: url(@/assets/Icons/downloadGray.png) no-repeat center/100% 100%; 
							&:hover{
								background-image: url(@/assets/Icons/downloadBlue.png);
							}
						}
						&:nth-of-type(1) {
							flex: 1 1 auto;
                            padding-right: .2rem;
						}
						&:last-child{
							flex: 0 0 auto;
							text-align: center;
						}
					}
				}
			}
          .dcLeft{
              width: 18.75%;
              background: #fff;

              dl{
                  padding: .3rem;
                  &:not(:last-child) {
                      margin-bottom: .1rem;
                  }
                  dt{
                      margin-bottom: .3rem;
                  }
                  ul li{
                      &:not(:last-child) {
                          margin-bottom: .2rem;
                      }
                      &:hover,&.active{
                          a{
                              color: #3076e3;
                          }
                          span{
                              background: #2657db;
                              color: #fff;
                          }
                      }
                      a{
                          display: block;
                          max-width: 85%;
                      }
                      span{
                          padding: 0 .07rem;
                          height: .2rem;
                          border-radius: .2rem;
                          background: #e4eef6;
                          color: #7cacd0;
                          margin-left: .1rem;
                          line-height: .2rem;
                          margin-top: -2px;
                      }
                  }
              }
          }
          @media (max-width: 1200px) {
              position: relative;
              overflow: hidden;
              min-height: 0;
              .dcLeft{
                  position: absolute;
                  left: -230px;
                  top: 0;
                  width: 230px;
                  transition: all .5s;
                  dl{
                      padding: .2rem;
                  }
              }
              .proDocument{
                  width: 100%;
                  transition: all .5s;
              }
              &.active{
                  .dcLeft{
                      left: 0;
                  }
                  .proDocument{
                      transform: translateX(240px);
                  }
              }
          }
      }
      
      .proDocument{
          .pdLeft{
              width: 85%;
              .tagList{
                  margin-top: .2rem;
                  padding-left: .3rem;
              }
          }
          .conmonDocument{
              ul li{
                  h3{
                      width: 100%;
                  }
              }
          }
      }
      
      .conmonDocument{
          padding: .3rem;
          .filter{
              .search{
                  margin-left: .2rem;
                  border-radius: 3px;
                  border: solid 1px #eee;
                  overflow: hidden;
                  input{
                      width: 2.8rem;
                      padding: 0 .15rem;
                      padding-right: .75rem;
                  }
                  button{
                      position: absolute;
                      right: 0;
                      top: 0;
                      width: .6rem;
                      background: #2657db;
                      color: #fff;
                      &:hover{
                          background: #003ee5;
                      }
                  }
                  input,button{
                      height: .33rem;
                      font-size: .16rem;
                  }
              }
              .sort{
                  
                  select{
                      margin-right: .1rem;
                      margin-left: 0;
                  }
                  img{
                      width: .2rem;
                  }
              }
              select{
                  font-size: .16rem;
                  width: 1.2rem;
                  height: .35rem;
                  border: solid 1px #eee;
                  border-radius: 3px;
                  padding-left: .15rem;
                  margin-left: .2rem;
                  background: url(@/assets/Icons/arrowDownGray.png) no-repeat 90% center/.15rem;
              }
          }
          @media (max-width: 640px) {
              .filter{
                  .rForm{
                      display: block;
                      margin-bottom: 10px;
                  }
                  .search{
                      margin: .2rem 0;
                      input{
                          width: calc(100% - .8rem);
                          
                      }
                      button{
                          width: .8rem;
                      }
                      input,button{
                          height: .5rem;
                          line-height: .5rem;
                      }
                  }
              }
              ul li{
                  padding-right: 0;
              }
          }
      }
  </style>
  